const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Bloomdale",

  webfeedDebuggerWebsiteUrl: "https://bloomdale.avid.com.au/land-for-sale/",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
